import { render, staticRenderFns } from "./AbsenceConfirmWaitingDayLegend.vue?vue&type=template&id=1500231b&"
import script from "./AbsenceConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceConfirmWaitingDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1500231b')) {
      api.createRecord('1500231b', component.options)
    } else {
      api.reload('1500231b', component.options)
    }
    module.hot.accept("./AbsenceConfirmWaitingDayLegend.vue?vue&type=template&id=1500231b&", function () {
      api.rerender('1500231b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/AbsenceConfirmWaitingDayLegend.vue"
export default component.exports